export const getParentElement = (el: Element): { el: Element; fromShadowRoot?: boolean } => {
  if (!el.parentElement) {
    const rootNodeEl = el.getRootNode();
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
    if ((rootNodeEl as ShadowRoot).host) {
      // Shadow root is the parent
      return { el: (rootNodeEl as ShadowRoot).host, fromShadowRoot: true };
    }
    throw new Error('Parent element not found.');
  }
  return { el: el.parentElement };
};

export const closestElement = (selector: string, el: any = this): Element | null => {
  if (!el) return null;

  return (
    (el && el !== document && el !== window && el.closest(selector)) || closestElement(selector, el.getRootNode().host)
  );
};

export const getHostFromEvent = (e: Event): Element | null => {
  const composedPath = e.composedPath();
  const target = composedPath[0] as HTMLElement;
  const targetRootNode = target.getRootNode();

  return (targetRootNode as ShadowRoot).host;
};
